import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import sentryService from './providers/sentry';

import translationCN from './translations/cn.json';
import translationEN from './translations/en.json';
import translationES from './translations/es.json';
import translationFR from './translations/fr.json';
import translationFR_BE from './translations/fr-BE.json';
import translationIT from './translations/it.json';
import translationNL from './translations/nl.json';
import translationRO from './translations/ro.json';
import translationTH from './translations/th.json';
import translationVI from './translations/vi.json';

const resources = {
  cn: {
    translation: translationCN,
  },
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
  fr: {
    translation: translationFR,
  },
  'fr-BE': {
    translation: translationFR_BE,
  },
  it: {
    translation: translationIT,
  },
  nl: {
    translation: translationNL,
  },
  ro: {
    translation: translationRO,
  },
  th: {
    translation: translationTH,
  },
  vi: {
    translation: translationVI,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: { 'fr-BE': ['fr'], default: ['fr'] },
    detection: {
      // navigator is the first priority, then querystring, cookie, localStorage, htmlTag
      order: ['navigator', 'querystring', 'cookie', 'localStorage', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    saveMissing: true,
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
      const isProduction =
        process.env.NODE_ENV === 'production' && process.env.REACT_APP_BUILD_ENV === 'production';

      if (!isProduction) {
        sentryService.send(
          `Missing translation key : ${key} in fallback language resource (${lng})`,
        );

        console.log(`Missing translation key : ${key} in fallback language resource (${lng})`);
      }
    },
  });

export default i18n;
